<div class="date-picker-extended-container">
	<div class="date-picker-extended-type">
		<label>
			<input type="radio" [checked]="type === 'Fixed'"
				   (change)="type = 'Fixed'; onTypeChanged()" />
			{{'FixedDate' | cpLabelTranslate}}
		</label>

		<label>
			<input type="radio" [checked]="type === 'Relative'"
				   (change)="type = 'Relative'; onTypeChanged()" />
			{{'RelativeDate' | cpLabelTranslate}}
		</label>
	</div>

	<div *ngIf="type === 'Fixed'">
		<div class="picker-control">
			<div *ngIf="dateType === 'Date'">
				<kendo-datepicker
						[ngClass]="{'kendo-date-picker-error': !validDate}"
						[format]="'Full'"
						[(value)]="selectedDate"
						(valueChange)="handleSelectionChange($event); validateDate()">
				</kendo-datepicker>
			</div>
			<div *ngIf="dateType === 'DateTime'">
				<kendo-datetimepicker
						[ngClass]="{'kendo-datetime-picker-error': !validDate}"
						[format]="format"
						[(value)]="selectedDate"
						(valueChange)="handleSelectionChange($event); validateDate()">
				</kendo-datetimepicker>
			</div>
		</div>
	</div>

	<div *ngIf="type === 'Relative'" class="date-picker-extended-relative-date">
		<div class="relative-date">
			<div class="start-wrapper">
				<label>{{'SelectedDate' | cpLabelTranslate}}:</label>
				<div class="start">
					<kendo-numerictextbox [(value)]="start"
										  [min]="0"
										  [max]="365"
										  [format]="'0'"
										  [autoCorrect]="true"
										  (valueChange)="computeRelativeDate(); buildRelativeDatesSimulateLabel()">
					</kendo-numerictextbox>
					<kendo-dropdownlist [(ngModel)]="startScale"
										[data]="scaleTypes"
										[textField]="'description'"
										[valueField]="'name'"
										(ngModelChange)="computeRelativeDate(); buildRelativeDatesSimulateLabel()">
					</kendo-dropdownlist>
					<label>{{'ago' | cpLabelTranslate}}</label>
				</div>
			</div>
		</div>
		<div class="relative-example-label">
			<label *ngIf="exampleLabel" [innerHTML]="exampleLabel"></label>
			<label *ngIf="exampleLabel === undefined">{{noStartDateSelectedText | cpLabelTranslate}}</label>
		</div>
	</div>
</div>
